/**
 * Build-time configuration.
 *
 * Source of truth = `firebase-config.ts` (committed, public values).
 * Optional Vite env vars (`VITE_FIREBASE_*`, `VITE_RECAPTCHA_SITE_KEY`)
 * may override individual fields locally — useful when pointing at a separate
 * Firebase project or testing alternative reCAPTCHA keys.
 *
 * Flavor comes from Vite's --mode flag (development | staging | production).
 */

import { ADMIN_FIREBASE_CONFIG } from "./firebase-config";

const mode = import.meta.env.MODE;

export const env = {
  flavor: mode === "production" ? "prod" : mode === "staging" ? "staging" : "dev",
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? ADMIN_FIREBASE_CONFIG.apiKey,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? ADMIN_FIREBASE_CONFIG.authDomain,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? ADMIN_FIREBASE_CONFIG.projectId,
    appId: import.meta.env.VITE_FIREBASE_APP_ID ?? ADMIN_FIREBASE_CONFIG.appId,
    messagingSenderId:
      import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? ADMIN_FIREBASE_CONFIG.messagingSenderId,
    storageBucket:
      import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? ADMIN_FIREBASE_CONFIG.storageBucket,
  },
  // `||` (not `??`) so an empty-string override in .env.local falls through to
  // the committed default. We were silently building with App Check disabled
  // because `VITE_RECAPTCHA_SITE_KEY=` (empty) survived `??`.
  recaptchaSiteKey:
    import.meta.env.VITE_RECAPTCHA_SITE_KEY || ADMIN_FIREBASE_CONFIG.recaptchaSiteKey,
  functionsRegion:
    import.meta.env.VITE_FUNCTIONS_REGION || ADMIN_FIREBASE_CONFIG.functionsRegion,
  isDev: import.meta.env.DEV,
  isProd: mode === "production",
};
